import React, { useContext, useEffect, useRef, useState } from "react";
import "./ActivityStreamTab.css"; // Import the CSS file
import { Col, Row } from "reactstrap";
import { Spin, Timeline } from "antd";
import ActivityTimeLine from "../../../common/ActivityStream/ActivityTimeLine";
import AwsServerService from "../../../common/util/AwsServerService";
import dayjs from "dayjs";
import { AppDataRequired } from "../../../App";
import swal from 'sweetalert';
import { useHistory } from "react-router-dom";
import { convertDateFromString } from "../../../components/ProjectTasks/Util";
import AppContext from "../../../Context/AppContext";
import { refershModule } from "../../../Context/AppActions";
import { getPriorityValue, invertColor, modifyTimezoneString } from "../../../components/HR/TimeClock/Util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FlagFilled } from "@ant-design/icons";
import { setRefershModule } from "../../../Context/ReduxContext";
import { useDispatch, useSelector } from "react-redux";


const ActivityStreamTab = ({ task,setScrollBottom, pipelineId, module, refreshData, allTasksAndSubtasks, viewTaskFunction, selectedActivityFilter, activityFilter, fromDeal, dealName, activityDealData }) => {
  const [activitiyData, setActivityData] = useState([]);
  const { AllUsers } = useContext(AppDataRequired);
  const AppData = useContext(AppContext);
  const { state, dispatch } = AppData || {};
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [pageSize,setPageSize] = useState(0);
  const [items,setItems] = useState([]);
  const [pipelines,setPipelines] = useState([]);
  const skipEffectRef = useRef(false);
  const bottomRef = useRef(null);
  const reduxDispatch = useDispatch();
  const RefershModule = useSelector((state) => state.AppReduxContext.refershModule)
  useEffect(()=>{
    if(pipelineId){
      if(module.includes('TEMPLATE')){
        AwsServerService.getPipelineTemplateNames().then(res=>{
          setPipelines(res[0])
        })
      }else{
        AwsServerService.getPipelineTemplateNames('true').then(res=>{
          setPipelines(res[0])
        })
      }
    }
  },[module,refreshData,pipelineId])
  function getActivityData(isLoad){
    if(isLoad!="load"){
      setLoading(true);
    }else{
      setLoadMore(true);
    }
    if(fromDeal){
      const filteredTaskActivity = activityDealData.filter((task)=>task?.SourceId == pipelineId)
       if(isLoad!="load"){
          setLoading(false);
          setActivityData(filteredTaskActivity);
        }else{
          setLoadMore(false);
          setActivityData(filteredTaskActivity)
        }
    } else {
    AwsServerService.getAllActivityByModule(pipelineId, module,selectedActivityFilter, pageSize,activityFilter.Sort,activityFilter.SearchText)
      .then((res) => {
        // res = res.sort(
        //   (a, b) => new Date(b?.CREATEDTIME) - new Date(a.CREATEDTIME)
        // );
        if(res?.length==0){
          skipEffectRef.current=true;
          setPageSize(pageSize-50);
        }
        if(isLoad!="load"){
          setLoading(false);
          setActivityData(res.reverse());
        }else{
          setLoadMore(false);
          setActivityData(prev=>[...res.reverse(),...prev])
        }
      })
      .catch((err) => { 
        skipEffectRef.current=true;
        setPageSize(pageSize-50); 
        setLoadMore(false);
        setLoading(false);
        // swal("Error!", "Something went wrong!", "error");
      });
  }
  }
  useEffect(e=>{
    if (fromDeal) return;
    if(skipEffectRef.current){
      skipEffectRef.current=false;
      return;
    }
    if(!fromDeal){
    if (pageSize > 50) {
      getActivityData("load");
    } else if(pageSize==50){
      getActivityData();
    }else if(!pageSize || pageSize==-1 ){
      setPageSize(50);
    }
    }
  },[pageSize])
  useEffect((e) => {
    if (!pipelineId) return;
    if (fromDeal) {
      setPageSize(Infinity);
      getActivityData();
    } else {
      setPageSize(-1);
    }
  },
    [pipelineId, refreshData,selectedActivityFilter,activityFilter.Sort,activityFilter.SearchText,activityDealData]
  );
  useEffect(e => {
    if (RefershModule && RefershModule.module == 'task-activity') {
      // getActivityData();
      setPageSize(-1);
      // getActivityData();
      reduxDispatch(setRefershModule({ module: "", data: "" }))
    }
  }, [RefershModule])

  // const getMessage = (text, user, allUsers) => {
  //   let firstPReplaced = false; // Track the first <p>
  //   let lastPIndex = text.lastIndexOf('</p>'); // Get the position of the last </p>
    
  //   let formattedText = text
  //     // Replace date strings with a formatted version
  //     .replace(/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}-\d{2}:\d{2})/g, match => convertDateFromString(match))
  //     // Replace <p> and </p> based on their positions
  //     .replace(/<\/?p>/g, (tag, offset) => {
  //       if (tag === '<p>') {
  //         if (!firstPReplaced) {
  //           firstPReplaced = true;
  //           return '<span>';
  //         }
  //         return '<br>';
  //       }
  //       if (tag === '</p>') {
  //         if (offset === lastPIndex) {
  //           return '</span>';
  //         }
  //         return ''; // Remove all other occurrences of </p>
  //       }
  //       return tag; // Fallback for unexpected cases
  //     });


  //   allUsers.forEach(otherUser => {
  //     const zuidRegex = new RegExp(`"${otherUser.zuid}"`, 'g');  // Looks for "zuid" with quotes
  //     formattedText = formattedText.replace(zuidRegex, `__ZUID_${otherUser.zuid}__`);
  //   });

  //   if (user) {
  //     formattedText = formattedText.replace("USER", "__USER__");
  //   }

  //   const parts = formattedText.split(/(__ZUID_\d+__|__USER__)/g);

  //   return (
  //     <>
  //       {parts.map((part, index) => {
  //         if (part.startsWith("__ZUID_")) {
  //           // Extract the ZUID from the placeholder and find the corresponding user
  //           const zuid = part.replace("__ZUID_", "").replace("__", "");
  //           const foundUser = allUsers.find(u => u.zuid === zuid);
  //           return foundUser ? (
  //             <a
  //               key={index}
  //               href="#"
  //               onClick={(e) => {
  //                 e.preventDefault();
  //                 history.push({
  //                   pathname: `/setting/users/${foundUser.id}/Users`,
  //                   state: { tab: "Users" },
  //                 });
  //               }}
  //               className="user-link"
  //             >
  //               {foundUser.full_name + " "}
  //             </a>
  //           ) : part;
  //         } else if (part === "__USER__" && user) {
  //           // Replace `USER` placeholder with a clickable user link for the main user
  //           return (
  //             <a
  //               key={index}
  //               href="#"
  //               onClick={(e) => {
  //                 e.preventDefault();
  //                 history.push({
  //                   pathname: `/setting/users/${user.user_id}/Users`,
  //                   state: { tab: "Users" },
  //                 });
  //               }}
  //               className="user-link"
  //             >
  //               {user.full_name + " "}
  //             </a>
  //           );
  //         } else if (/<[^>]+>/.test(part)) {
  //           // Handle HTML content with dangerouslySetInnerHTML
  //           return (
  //             <span
  //               key={index}
  //               dangerouslySetInnerHTML={{ __html: part }}
  //             />
  //           );
  //         }
  //         else if (part.match(/\S+_\S+$/)) {
  //           let parts = part.split(/\s+/);
  //           let result = parts.map((word) => {
  //             let value = word.match(/\S+_\S+/);
  //             if (value) {
  //               let [taskKey, taskId] = value[0].split('_');
  //               let task = allTasksAndSubtasks[taskKey]?.get(Number(taskId));
  //               if (task) {
  //                 return (
  //                   <span>
  //                     {word.replace(value[0], "")}
  //                     <span className="taskNameClass" onClick={() => viewTaskFunction([taskKey, taskId])}>
  //                       {" " + task?.TaskName + " "}
  //                     </span>
  //                   </span>
  //                 );
  //               }
  //             }
  //             return word + " ";
  //           });
  //           return <span>{result}</span>;
  //         } else {
  //           // Render plain text for other parts
  //           return <span key={index}>{part}</span>;
  //         }
  //       })}
  //     </>
  //   );
  // };
 const unmarkedIcon = (
  <svg
    onClick={(e) => {
      e.stopPropagation();
    }}
    style={{ background: "#f2f2f2", borderRadius: "25%" }}
    height="20"
    viewBox="0 0 64 64"
    width="22"
    id="fi_10529846"
  >
    <g id="Icons">
      <g>
        <path
          d="m46.333 26 5.382-8.971c.371-.618.38-1.387.025-2.014s-1.019-1.015-1.74-1.015h-14c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h14c.721 0 1.385-.388 1.74-1.015s.346-1.396-.025-2.014z"
          fill="#a8072fff"
        ></path>
        <g>
          <path
            d="m42 35c1.104 0 2-.896 2-2v-19h-8c-1.104 0-2 .896-2 2v19z"
            fill="#9c1722ff"
          ></path>
        </g>
        <g>
          <path
            d="m24 60h-4c-4.411 0-8-3.589-8-8s3.589-8 8-8h4c4.411 0 8 3.589 8 8s-3.589 8-8 8zm-4-12c-2.206 0-4 1.794-4 4s1.794 4 4 4h4c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
            fill="#f1b15dff"
          ></path>
        </g>
        <g>
          <path
            d="m22 54c-1.104 0-2-.896-2-2v-46c0-1.104.896-2 2-2s2 .896 2 2v46c0 1.104-.896 2-2 2z"
            fill="#0a5078"
          ></path>
        </g>
        <g>
          <path
            d="m24 8h-4c-1.105 0-2-.895-2-2 0-1.105.895-2 2-2h4c1.105 0 2 .895 2 2 0 1.105-.895 2-2 2z"
            fill="#fab400"
          ></path>
        </g>
        <path
          d="m42 10h-22v24h22c1.104 0 2-.896 2-2v-20c0-1.104-.896-2-2-2z"
          fill="#c80a50"
        ></path>
        <g>
          <path d="m20 8h4v1h-4z" fill="#00325a"></path>
        </g>
        <g>
          <path d="m20 34h4v1h-4z" fill="#00325a"></path>
        </g>
        <g>
          <path
            d="m25 48.127v-4.064c-.328-.042-.661-.063-1-.063v4c.345 0 .68.044 1 .127z"
            fill="#0082aa"
          ></path>
        </g>
      </g>
    </g>
        <circle cx="32" cy="32" r="30" stroke="black" strokeWidth="2" fill="none" />
    <line x1="10" y1="10" x2="54" y2="54" stroke="red" strokeWidth="3" />
    <line x1="54" y1="10" x2="10" y2="54" stroke="red" strokeWidth="3" />
  </svg>
);
  
  const markedIcon =(
  <svg
    onClick={(e) => {
      e.stopPropagation();
    }}
    style={{ background: "#f2f2f2", borderRadius: "25%" }}
    height="20"
    viewBox="0 0 64 64"
    width="22"
    id="fi_10529846"
  >
    <g id="Icons">
      <g>
        <path
          d="m46.333 26 5.382-8.971c.371-.618.38-1.387.025-2.014s-1.019-1.015-1.74-1.015h-14c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h14c.721 0 1.385-.388 1.74-1.015s.346-1.396-.025-2.014z"
          fill="#a8072fff"
        ></path>
        <g>
          <path
            d="m42 35c1.104 0 2-.896 2-2v-19h-8c-1.104 0-2 .896-2 2v19z"
            fill="#9c1722ff"
          ></path>
        </g>
        <g>
          <path
            d="m24 60h-4c-4.411 0-8-3.589-8-8s3.589-8 8-8h4c4.411 0 8 3.589 8 8s-3.589 8-8 8zm-4-12c-2.206 0-4 1.794-4 4s1.794 4 4 4h4c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
            fill="#f1b15dff"
          ></path>
        </g>
        <g>
          <path
            d="m22 54c-1.104 0-2-.896-2-2v-46c0-1.104.896-2 2-2s2 .896 2 2v46c0 1.104-.896 2-2 2z"
            fill="#0a5078"
          ></path>
        </g>
        <g>
          <path
            d="m24 8h-4c-1.105 0-2-.895-2-2 0-1.105.895-2 2-2h4c1.105 0 2 .895 2 2 0 1.105-.895 2-2 2z"
            fill="#fab400"
          ></path>
        </g>
        <path
          d="m42 10h-22v24h22c1.104 0 2-.896 2-2v-20c0-1.104-.896-2-2-2z"
          fill="#c80a50"
        ></path>
        <g>
          <path d="m20 8h4v1h-4z" fill="#00325a"></path>
        </g>
        <g>
          <path d="m20 34h4v1h-4z" fill="#00325a"></path>
        </g>
        <g>
          <path
            d="m25 48.127v-4.064c-.328-.042-.661-.063-1-.063v4c.345 0 .68.044 1 .127z"
            fill="#0082aa"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
;

  const getMessage = (text, user, allUsers) => {
      let firstPReplaced = false; // Track the first <p>
      let lastPIndex = text.lastIndexOf('</p>'); // Get the position of the last </p>
      if(text.includes("Supervisor")){
        text = text.replace("Supervisor", "Project Manager")
      }
      // Replace <p> and </p> based on their positions
      let formattedText = text.replace(/<\/?p>/g, (tag, offset) => {
          if (tag === '<p>') {
              if (!firstPReplaced) {
                  firstPReplaced = true;
                  return '<span>';
              }
              return '<br>';
          }
          if (tag === '</p>') {
              if (offset === lastPIndex) {
                  return '</span>';
              }
              return ''; // Remove all other occurrences of </p>
          }
          return tag; // Fallback for unexpected cases
      });

        if(formattedText.includes("started working on this task from")){
          const dateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?([+-]\d{2}:\d{2}|Z)?/g;
            formattedText = formattedText.replace(dateRegex, (dateString) => {
                const dayjsObj = dayjs(dateString); // Parse the date string
                // If the date is today, format as time; otherwise, format as date
                return dayjs().isSame(dayjsObj, 'day')
                    ? dayjsObj.format('MM-DD-YYYY hh:mm A') // Format as time for today
                    : dayjsObj.format('MMM DD, YYYY'); // Format as date for other days
            });
        }else{
          // const dateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/g;
          const dateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?/g;

          formattedText = formattedText.replace(/Start-Date|Due-Date/g, match => ({
            'Start-Date': 'Start Date',
            'Due-Date': 'Due Date'
          }[match]));
          formattedText = formattedText.replace(dateRegex, (dateString) => {
              return dayjs(dateString).format('MMM DD, YYYY'); // Format to MM DD YYYY
          });
        }
  
      allUsers.forEach(otherUser => {
          const zuidRegex = new RegExp(`"${otherUser.zuid}"`, 'g'); // Looks for "zuid" with quotes
          formattedText = formattedText.replace(zuidRegex, `__ZUID_${otherUser.zuid}__`);
          formattedText = formattedText.replace('""', '"none"')
      });
  
      if (user) {
          formattedText = formattedText.replaceAll("USER", "__USER__");
      }
  
      // Replace priority words with placeholders to avoid multiple splits
      const priorityPlaceholders = {
          "Not Set": "__PRIORITY_NOT_SET__",
          "Low": "__PRIORITY_LOW__",
          "Medium": "__PRIORITY_MEDIUM__",
          "High": "__PRIORITY_HIGH__",
      };
  
      Object.keys(priorityPlaceholders).forEach(priority => {
          const placeholder = priorityPlaceholders[priority];
          const regex = new RegExp(`\\b${priority}\\b`, 'g'); // Match the priority word
          formattedText = formattedText.replace(regex, placeholder);
      });

      if (formattedText.includes("Status")) {
        const statusRegex = /Status.*?from\s"([^"]*?)"\sto\s"([^"]*?)"/i; // Matches "Status ... from "old" to "new""
        const match = formattedText.match(statusRegex);

        if (match) {
            const [_, oldStatus, newStatus] = match;
            let oldStatusNode='';
            let newStatusNode='';
            if (task) {
              // Filter and find the node that matches the oldStatus
              oldStatusNode = task?.TaskFlowObject?.Nodes?.find(
                  (node) => node.data.label === oldStatus
              );
          
              // Filter and find the node that matches the newStatus
              newStatusNode = task?.TaskFlowObject?.Nodes?.find(
                  (node) => node.data.label === newStatus
              );
            }
            // console.log("oldStatusNode", oldStatusNode)
            // console.log("newStatusNode", newStatusNode)
            const oldStatusColor = oldStatusNode?.data?.color != "grey" ? oldStatusNode?.data?.color : "#808080"; // Default gray if not found
            const newStatusColor = newStatusNode?.data?.color != "grey" ? newStatusNode?.data?.color : "#808080"; // Default gray if not found
            // Replace the old and new statuses in the formattedText with styled spans
            formattedText = formattedText.replace(
                `"${oldStatus}"`,
                `<span class="old-status" style="background-color:${oldStatusColor};color:${invertColor(oldStatusColor,true)};">${oldStatus}</span>`
            );

            formattedText = formattedText.replace(
                `"${newStatus}"`,
                `<span class="new-status" style="background-color:${newStatusColor};color:${invertColor(newStatusColor,true)};">${newStatus}</span>`
            );
        }
    }
      if(formattedText.includes('changed the task Pipeline from')){
        formattedText = formattedText.replace(/"(\d+)"/g, (match, id) => {
          const pipeline = pipelines.find(p => Number(p.ROWID) == Number(id));
          return `"${pipeline?.PipelineName || `${id} (Deleted Pipeline)`}"`;
        });
      }
      // Split the text into parts
      const parts = formattedText.split(/(__ZUID_\d+__|__USER__|__PRIORITY_[A-Z_]+__)/g)
                                 .filter(part => part !== undefined);
      const sentenceToFind = "this task as milestone"; 

      return (
        <>
              {parts?.map((part, index) => {
                  if (part?.startsWith("__ZUID_")) {
                      // Extract the ZUID from the placeholder and find the corresponding user
                      const zuid = part.replace("__ZUID_", "").replace("__", "");
                      const foundUser = allUsers.find(u => u.zuid === zuid);
                      return foundUser ? (
                          <a
                              key={index}
                              href="#"
                              onClick={(e) => {
                                  e.preventDefault();
                                  history.push({
                                      pathname: `/setting/users/${foundUser.id}/Users`,
                                      state: { tab: "Users" },
                                  });
                              }}
                              className="user-link"
                          >
                              {foundUser.full_name + " "}
                          </a>
                      ) : part;
                  } else if(part.includes(sentenceToFind)) {
                    let unmarked = part.includes("unmarked");
                    const cleanedPart = part.replace(/\./g, ''); 
                      return (
                           <span key={index}>
                            {cleanedPart} {unmarked ? unmarkedIcon : markedIcon}
                        </span>
                      );
                  } else if (part === "__USER__" && user) {
                      // Replace `USER` placeholder with a clickable user link for the main user
                      return (
                          <a
                              key={index}
                              href="#"
                              onClick={(e) => {
                                  e.preventDefault();
                                  history.push({
                                      pathname: `/setting/users/${user.user_id}/Users`,
                                      state: { tab: "Users" },
                                  });
                              }}
                              className="user-link"
                          >
                              {user.full_name + " "}
                          </a>
                      );
                  } else if (part?.startsWith("__PRIORITY_")) {
                      // Render priority with Ant Design FlagFilled icon
                      const priority = part.replace("__PRIORITY_", "");
                      const colorMapping = {
                          "NOT_SET": "gray",
                          "LOW": "blue",
                          "MEDIUM": "orange",
                          "HIGH": "red",
                      };
                      let priorityText = priority
                      .split('_') // Split the string by the underscore
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                      .join('_');
                      priorityText = priorityText?.replaceAll("__", "").replaceAll("_", " ")
                      // console.log("first", getPriorityValue(priorityText?.replaceAll("_", "")))
  
                      return (
                          <span
                              key={index}
                              style={{
                                  color: getPriorityValue(priorityText)
                              }}
                              className="Activity-Priority"
                          >
                              <FlagFilled style={{ marginRight: 4 ,marginLeft: 2 , color: getPriorityValue(priorityText)}} />
                              {priorityText}
                          </span>
                      );
                  } else if (/<[^>]+>/.test(part)) {
                      // Handle HTML content with dangerouslySetInnerHTML
                      return (
                          <span
                              key={index}
                              dangerouslySetInnerHTML={{ __html: part }}
                          />
                      );
                  } else if (part?.match(/\S+_\S+$/)) {
                    let parts = part.split(/\s+/);
                    let result = parts.map((word) => {
                      let value = word.match(/\S+_\S+/);
                      if (value) {
                        let [taskKey, taskId] = value[0].split('_');
                        console.log("Tasks:-", task)
                        let task1 = fromDeal == true ? task : allTasksAndSubtasks[taskKey]?.get(Number(taskId));
                        if (task1) {
                          return (
                            <span>
                              {word.replace(value[0], "")}
                              <span className="taskNameClass" onClick={() => viewTaskFunction([taskKey, taskId])}>
                                {" " + task1?.TaskName + " "}
                              </span>
                            </span>
                          );
                        }
                      }
                      return word + " ";
                    });
                    return <span>{result}</span>;
                  }else {
                      // Render plain text for other parts
                      return <span key={index}>{part}</span>;
                  }
              })}
          </>
      );
  };

  const getUserThumbnailUrl = (zuid) => {
    const loginProfileUrl =
      "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
    return loginProfileUrl;
  };

  const RenderChildren = (data) => {
    data = data?.data ? data?.data : data;
    let user = AllUsers.find(d => d.zuid == data?.ActivityOwner || d.email == data?.ActivityOwner);
    return (
      data?.Message && <div className="Activity-Data-Wrapper">
        <span style={{ minWidth: "3rem" }}>
          <img
            className="User-Image"
            src={getUserThumbnailUrl(user?.zuid)}
          />
        </span>
        <div>
          <p className="activity-message">
            {data?.Message ? getMessage(data?.Message, user, AllUsers) : <></>}
          </p>
          <span className="activity-date">
            {dayjs(modifyTimezoneString(data?.CREATEDTIME)).format("MMM DD YYYY hh:mm A")}
          </span>
        </div>
      </div>
    );
  };

  useEffect(e=>{
    setScrollBottom(prev=>prev+1);
  },[items])

  useEffect(e => {
    if (activitiyData) {
      let temp = activitiyData
        .filter(item => item?.Message)
        .map((item, ind) => {
          return {
            children: <RenderChildren id={"Timeline_"+ind} data={item} />,
          };
        });
      setItems(temp)
    }else{
      setItems([]);
    }
  }, [activitiyData])
  function loadMoreData(){
    setPageSize((pageSize+50));
  }
  return (
    <div className="Actvity-Items-Wrapper">
      {loading ? <div style={{
        display: "flex", width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
      }} ><Spin className='mr-2' tip="Loading" size='small' /></div> :
        <>
          <span className="LoadMore-Class" onClick={loadMoreData}>{loadMore && <Spin className='mr-2' tip="Loading" size='small' />}Load more<FontAwesomeIcon className="ml-1" icon={faArrowDown}/></span>
          <ActivityTimeLine  items={items} loadMore={loadMore} />
          <div ref={bottomRef} />
        </>}
    </div>
  );
};

export default ActivityStreamTab;